import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import ILottoStatisticsDto from '@core/mappers/lotto/dtos/ILottoStatisticsDto';
import LottoStatistics from '@core/models/lotto/LottoStatistics';

export default class LottoStatisticsMapper extends AbstractMapper<ILottoStatisticsDto, LottoStatistics> {

    createTargetObject(dto: ILottoStatisticsDto, key: string): LottoStatistics {
        const statistics = new LottoStatistics();

        statistics.fiveMostRare = dto.fiveMostRare;
        statistics.fiveMostFrequent = dto.fiveMostFrequent;
        statistics.twoMostFrequent = this.createNumbers(dto.twoMostFrequent);
        statistics.threeMostFrequent = this.createNumbers(dto.threeMostFrequent);
        statistics.twoMostConsecutive = this.createNumbers(dto.twoMostConsecutive);
        statistics.threeMostConsecutive = this.createNumbers(dto.threeMostConsecutive);
        statistics.singles = this.mapSingles(dto.singles);

        return statistics;
    }

    mapSingles(singlesDto: Record<string, {o: number, f: number}>)
    : Record<number, {appearanceNumber: number, roundsWithoutAppearance: number}> {
        const singles = {} as Record<string, {appearanceNumber: number, roundsWithoutAppearance: number}>;
        Object.keys(singlesDto).forEach((element) => {
            singles[element] = {
                appearanceNumber: singlesDto[element].o,
                roundsWithoutAppearance: singlesDto[element].f,
            };
        });

        return singles;
    }

    createNumbers(numbers: string[]): number[] {
        const result: number[] = [];
        numbers.forEach((num: string) => {
            const value = parseInt(num, 10);
            if (isNaN(value)) {
                return;
            }
            result.push(value);
        });
        return result.length === numbers.length ? result : [];
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/lotto/LottoStatisticsMapper.ts